import * as React from "react";
import Box from "@material-ui/core/Box";
import {Header} from "./header";
import {Sidebar} from "./sidebar";
import styled from "styled-components";
import BackgroundRightGirl from '../../img/background-right-girl.png';
import {Grid} from "@material-ui/core";
import {Colors} from "../../theme/colors";

export const Layout: React.FC<any> = ({children, userLogged}) => {
    return (
        <StyledMainGrid container direction={"row"}>
            <StyledLayoutBox>
                <Sidebar/>
            </StyledLayoutBox>

            <StyledContentGrid>
                <Header/>

                <StyledContentBox
                    flex={1}
                >
                    {userLogged && children}
                </StyledContentBox>
            </StyledContentGrid>
        </StyledMainGrid>
    );
}

const StyledMainGrid = styled(Grid)`
  background-color: ${Colors.primary95};
  flex-wrap: nowrap !important;
  overflow-x: hidden;
  max-width: 100%;
`;

const StyledLayoutBox = styled(Grid)`
  min-height: 100vh;
  display: flex;
  flex: 0;
`;

const StyledContentGrid = styled(Grid)`
  display: flex;
  flex: auto;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
`;

const StyledContentBox = styled(Box)`
  padding: 20px;
`;
